import { bannersConstants } from "../constants/bannersConstants";

const initialState = {
  sending: false,
  bannersResponse: {},
  error: "",
  fetching: "",
  fetchingSites: false,
  bannersList: {},
  deletedBanners: {},
  updatedBanners: {},
  bannersData: [],
  fetchBanners: false,
  fetchingBanners: false,
  sendingBannersData: false,
  bannersUpdate: {},
  siteList: {}
};

export default function bannersReducer(state = initialState, action) {
  switch (action.type) {
    case bannersConstants.ADD_BANNERS_REQUEST:
      return {
        ...state,
        sendingBannersData: true
      };
    case bannersConstants.ADD_BANNERS_SUCCESS:
      return {
        ...state,
        sendingBannersData: false,
        bannersResponse: action.banners,
        error: ""
      };
    case bannersConstants.ADD_BANNERS_FAILURE:
      return {
        ...state,
        sendingBannersData: false,
        error: action.error
      };
    case bannersConstants.FETCH_BANNERS_REQUEST:
      return {
        ...state,
        fetchingBanners: true
      };
    case bannersConstants.FETCH_BANNERS_SUCCESS:
      return {
        ...state,
        fetchingBanners: false,
        bannersList: action.banners.data,
        bannersData: action.banners.data.data,
        bannersResponse: {},
        bannersUpdate: {},
        error: ""
      };
    case bannersConstants.FETCH_BANNERS_FAILURE:
      return {
        ...state,
        fetchingBanners: false,
        error: action.error
      };
    case bannersConstants.DELETE_BANNERS_REQUEST:
      return {
        ...state,
        fetching: true
      };
    case bannersConstants.DELETE_BANNERS_SUCCESS:
      return {
        ...state,
        deletedBanners: action.banners,
        error: ""
      };
    case bannersConstants.DELETE_BANNERS_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case bannersConstants.GET_BANNERS_DETAILS_REQUEST:
      return {
        ...state,
        fetchBanners: true
      };
    case bannersConstants.GET_BANNERS_DETAILS_SUCCESS:
      return {
        ...state,
        fetchBanners: false,
        bannersDetails: action.bannersDetails,
        error: ""
      };
    case bannersConstants.GET_BANNERS_DETAILS_FAILURE:
      return {
        ...state,
        fetchBanners: false,
        error: action.error
      };
    case bannersConstants.FETCH_SITELIST_REQUEST:
      return {
        ...state,
        fetchingSites: true
      };
    case bannersConstants.FETCH_SITELIST_SUCCESS:
      return {
        ...state,
        fetchingSites: false,
        siteList: action.sitelist.data,
        error: ""
      };
    case bannersConstants.FETCH_SITELIST_FAILURE:
      return {
        ...state,
        fetchingSites: false,
        error: action.error
      };   
    case bannersConstants.UPDATE_BANNERS_REQUEST:
      return {
        ...state,
        sendingBannersData: true
      };
    case bannersConstants.UPDATE_BANNERS_SUCCESS:
      return {
        ...state,
        bannersUpdate: action.updatedBanners,
        sendingBannersData: false,
        error: ""
      };
    case bannersConstants.UPDATE_BANNERS_FAILURE:
      return {
        ...state,
        error: action.error,
        sendingBannersData: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/bannersReducers.js